export default "__VITE_ASSET__z3ICRn1U__"